import type { ConfirmationResponse } from "@/features/register/types";
import { useMutation, type UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { AuthApiClient } from "../api-client/api-client";
import type { AliasDelete } from "../types";
import { useCompanyContext } from "@/features/company/hooks/use-company-context";
import { QueryOptionsFactory } from "@/features/company/utils";

export const useDeleteAlias = (
  options?: UseMutationOptions<ConfirmationResponse, Error, AliasDelete>
) => {
  const queryClient = useQueryClient();
  const { leUuid } = useCompanyContext();
  return useMutation<ConfirmationResponse, Error, AliasDelete>({
    mutationFn: async (deleteParams) => AuthApiClient.deleteAlias(deleteParams, leUuid),
    onSuccess: () =>
      leUuid
        ? queryClient.invalidateQueries({
            queryKey: QueryOptionsFactory.legalEntity(leUuid ?? "").queryKey
          })
        : queryClient.invalidateQueries({ queryKey: ["user", "profile"] }),
    ...options
  });
};
